const PaymentLogos = () => (
  <div className="flex flex-row gap-2 m-4 mt-4 justify-center self-center h-8">
    <img
      alt="stripe power icon"
      width={110}
      src="https://www.hobbyresources.com/cc/resources/15e5b753-3c25-40e2-873c-6f00b486d7c5/powered-by-stripe.png"
    />
    <img
      alt="ssl checkout icon"
      width={150}
      src="https://www.hobbyresources.com/cc/resources/398730e5-5773-45df-b82d-090398163d94/ssl-secure-trust-badge-free.png"
    />
  </div>
);

export default PaymentLogos;
